import { useFormContext, Controller } from "react-hook-form";
import { OnboardingFormData } from "../OnboardingPage";
import {
  RevCard,
  RevCheckbox,
  RevRadioGroup,
  RevSlider,
} from "@revmatics/catalyst";
import { fullFormatNumbers } from "../../../helpers/functions/formatNumber.ts";

export const Step2_GrowthChallenges = () => {
  const { control, register } = useFormContext<OnboardingFormData>();

  return (
    <div>
      <RevCard
        title="Your Goals"
        text="Let's unlock your revenue potential!"
        textSize="typography-body-xs"
        className="!px-4 !pb-4"
      >
        <div className="text-left space-y-6">
          <h6 className="mb-3">What's your biggest growth challenge?</h6>
          <Controller
            name="growthChallenge"
            control={control}
            rules={{
              validate: (value) => value.length > 0,
            }}
            render={({ field }) => (
              <div className="space-y-2">
                {[
                  "Getting traffic",
                  "Converting visitors",
                  "Finding right audiences",
                  "Scaling what works",
                  "I don't know",
                ].map((value) => (
                  <RevCheckbox
                    key={value}
                    label={value}
                    checked={field.value?.includes(value)}
                    handleChecked={() => {
                      const newValue = field.value?.includes(value)
                        ? field.value.filter((v) => v !== value)
                        : [...(field.value || []), value];
                      field.onChange(newValue);
                    }}
                    className="!items-center"
                  />
                ))}
              </div>
            )}
          />
        </div>

        <div className="mt-6">
          <h6 className="mb-8">Monthly marketing budget</h6>
          <Controller
            name="marketingBudget"
            control={control}
            render={({ field }) => (
              <RevSlider
                className="max-w-[495px]"
                name={field.name}
                value={field.value}
                onChange={field.onChange}
                leftLabel="$0"
                rightLabel="$1M+"
                minValue={0}
                maxValue={1000000}
                labelPosition="bottom"
                formatTooltip={(value) =>
                  `$${fullFormatNumbers({
                    value,
                    shortenValue: 1e3,
                    decimalCount: value > 1e6 ? 1 : 0,
                  })}`
                }
                isSmooth
                isTooltipVisible
              />
            )}
          />
        </div>

        <div>
          <h6 className="pt-4">Have you worked with creators before?</h6>
          <Controller
            name="creatorExperience"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <RevRadioGroup
                {...field}
                options={[
                  { label: "Yes, successfully", value: "yes_good" },
                  { label: "Yes, but disappointed", value: "yes_bad" },
                  { label: "No, but interested", value: "no_interested" },
                  { label: "No, seems complicated", value: "no_complicated" },
                ]}
                displayDirection="vertical"
              />
            )}
          />
        </div>
        <input
          type="hidden"
          {...register("validHelper", {
            shouldUnregister: true,
          })}
        />
      </RevCard>
    </div>
  );
};
